import { render, staticRenderFns } from "./ProductDetailPage.vue?vue&type=template&id=b6e7760e"
import script from "./ProductDetailPage.vue?vue&type=script&lang=js"
export * from "./ProductDetailPage.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailPage.vue?vue&type=style&index=0&id=b6e7760e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports